export const SET_JOB = 'SET_JOB'
export const SET_JOBS = 'SET_JOBS'
export const CLEAR_JOBS = 'CLEAR_JOBS'
export const SET_SELECTED_JOB = 'SET_SELECTED_JOB'
